<div class="editable-container" [ngClass]="{ 'hovered': isHovered, 'editing': isEditing }" (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()">
    <div *ngIf="!isEditing; else editTemplate" class="url-container">
        <a *ngIf="currentValue !== null && (currentValue || currentValue.toString() === '0'); else emptyTemplate"  
        [href]="goTo()" target='_blank'>{{
            currentValue }}</a>
        <ng-template #emptyTemplate>
            <span class="empty-text" (click)="startEditing()">{{ placeholder }}</span>
        </ng-template>
        <em nz-icon nzType="highlight" nz-button (click)="startEditing()" nz-tooltip="Edit"></em>
    </div>
    <ng-template #editTemplate>
        <ng-container>
            <textarea #editorTextArea nz-input [(ngModel)]="inputValue" (focus)="startEditing()" (blur)="onBlur()"
                [rows]="rows" (keydown)="onKeydown($event)"></textarea>
        </ng-container>
    </ng-template>
</div>